import { render, staticRenderFns } from "./MessageCozy.vue?vue&type=template&id=a6a2cf0c&scoped=true&"
import script from "./MessageCozy.vue?vue&type=script&lang=js&"
export * from "./MessageCozy.vue?vue&type=script&lang=js&"
import style0 from "./MessageCozy.vue?vue&type=style&index=0&id=a6a2cf0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a2cf0c",
  null
  
)

export default component.exports